'use client';

import { useHorizontalScroll } from '@/hooks/useHorizontalScroll';
import { cn } from '@/lib/utils';

import { EdgeFade } from '@/components/atoms/EdgeFade';

import { IconLinkCard, IconLinkItem } from './IconLinkCard';

export type IconLinkCardsProps = {
  items: IconLinkItem[];
  className?: string;
};

const MAX_ROWS = 2;

export default function IconLinkCards({
  items,
  className,
}: IconLinkCardsProps) {
  const { viewportRef, fadeSides } = useHorizontalScroll(items.length);

  const half = Math.ceil(items.length / MAX_ROWS);
  const rows = [items.slice(0, half), items.slice(half)].filter(
    (row) => row.length > 0
  );

  return (
    <div className={cn('group/cards w-full', className)}>
      <EdgeFade tone='dark' sides={fadeSides}>
        <div
          ref={viewportRef}
          // py-1/-my-1 keeps focus outlines from being clipped by the scroll container
          className='-my-1 overflow-x-auto py-1 scrollbar-none'
          role='region'
          aria-label='Icon links'
          tabIndex={0}
        >
          <div className='flex flex-col gap-3'>
            {rows.map((row, rowIndex) => (
              <ul
                key={rowIndex}
                className='flex gap-5'
                aria-label={`Row ${rowIndex + 1}`}
              >
                {row.map((item, index) => (
                  <li key={index}>
                    <IconLinkCard item={item} />
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </EdgeFade>
    </div>
  );
}
